import React from 'react';
import { MDXProvider } from '@mdx-js/react';
import { MDXRenderer } from 'gatsby-plugin-mdx';
import styled from 'styled-components';

import MDXComponents from 'src/components/mdx-components';
import { Section, SectionHeader } from 'src/components/molecules/Section';
import { Grid, Column } from 'src/components/molecules/Grid';
import { Button } from 'src/components/atoms/Button';
import { InlineList } from 'src/components/molecules/InlineList';
import { FluidImg, FixedImg } from 'src/embeds/image/image-dato';

const BackgroundContainer = styled.section`
  background-image: ${({ backgroundImageUrl }) => `url(${backgroundImageUrl})`};
  background-repeat: no-repeat;
  background-color: #000000;

  @media (min-width: ${({ theme }) => theme.mediumBreakpoint}) {
    background-size: contain;
    background-position: -70%;
  }
`;

export default function Drawer({
  heading,
  content,
  contentNode,
  callouts,
  ctas,
  customData,
  preHeadingImage,
  backgroundImage,
}) {
  callouts = callouts.filter((callout) => callout.__typename == 'DatoCmsCallout');
  const drawerCustomData = JSON.parse(customData);
  return (
    <MDXProvider components={MDXComponents}>
      <BackgroundContainer backgroundImageUrl={backgroundImage?.url}>
        <Section centered {...drawerCustomData?.flags} customTextColor={'#fff'}>
          <SectionHeader centered={drawerCustomData?.flags?.centered}>
            {preHeadingImage && (
              <FluidImg
                data={preHeadingImage}
                width={preHeadingImage.width}
                role="presentation"
                maxWidth="100%"
                style={{
                  marginRight: '0.5rem',
                }}
                constrain
              />
            )}

            {!!heading && <h2>{heading}</h2>}
            {content.length > 0 && <MDXRenderer>{contentNode.childMdx.body}</MDXRenderer>}
          </SectionHeader>

          {callouts.length > 0 ? (
            <Grid tiny {...drawerCustomData?.gridProps} colSpan={4} rowSpan={2} columns="1fr 1fr 1fr 1fr">
              {callouts.map(
                ({ heading, content, contentNode, media, customData, preHeading, preHeadingImage }, i) => {
                  customData = JSON.parse(customData);
                  return (
                    <Column
                      {...customData?.columnProps}
                      key={i}
                      style={{ border: '1px solid white', borderRadius: '10px', padding: '1rem' }}
                    >
                      {media && (
                        <FixedImg
                          css={`
                            margin-bottom: 20px;
                          `}
                          data={media}
                          width={media.width}
                          role="presentation"
                          maxWidth="100%"
                          constrain
                        />
                      )}
                      {preHeading && (
                        <div
                          style={{
                            display: 'flex',
                            marginBottom: '1rem',
                            alignItems: 'center',
                          }}
                        >
                          {preHeadingImage && (
                            <FixedImg
                              data={preHeadingImage}
                              width={preHeadingImage.width}
                              role="presentation"
                              maxWidth="100%"
                              style={{
                                marginRight: '0.5rem',
                              }}
                              constrain
                            />
                          )}
                          <div className="f-mono">
                            <small>{preHeading}</small>
                          </div>
                        </div>
                      )}
                      {heading && preHeadingImage ? (
                        <div>
                          <div style={{ display: 'flex', alignItems: 'center', marginBottom: '1rem' }}>
                            <FixedImg
                              data={preHeadingImage}
                              width={preHeadingImage.width}
                              role="presentation"
                              maxWidth="100%"
                              style={{
                                marginRight: '0.5rem',
                              }}
                              constrain
                            />
                            <h3 style={{ margin: 0 }}>{heading}</h3>
                          </div>
                        </div>
                      ) : (
                        <small>
                          <div>{heading}</div>
                        </small>
                      )}
                    </Column>
                  );
                },
              )}
            </Grid>
          ) : null}
          {ctas.length > 0 && (
            <InlineList centered style={{ width: '100%', paddingTop: 80 }}>
              {ctas.map((cta, i) => {
                const ctaFlags = i > 0 ? { secondary: true } : {};
                return (
                  <li key={i}>
                    <Button to={cta.url} {...ctaFlags}>
                      {cta.text}
                    </Button>
                  </li>
                );
              })}
            </InlineList>
          )}
        </Section>
      </BackgroundContainer>
    </MDXProvider>
  );
}
